import type { ReactNode } from 'react'
import { Helmet } from '#src/components/Helmet.tsx'
import { DocumentInboxContent } from '#src/pages/document-inbox/DocumentInboxContent.tsx'

export function DocumentInboxPage(): ReactNode {
  return (
    <div className="relative flex size-full flex-col print:size-auto">
      <Helmet title="Document Inbox" />
      <div className="space-y-1 border-b px-pagex-default py-4 lg:px-pagex-lg">
        <h1 className="text-2xl font-semibold">Document Inbox</h1>
      </div>
      <div className="flex flex-1 overflow-hidden">
        <DocumentInboxContent />
      </div>
    </div>
  )
}
